import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import usePolling from 'Shared/hooks/usePolling'
import useSessionStatusData from './useSessionStatusData'
import { JobStatusEnum } from '../constants'
import { pollCloneSessionJobsByID } from '../reducers/clone_leagues_sessions_jobs_poller'

const POLL_INTERVAL = 3000

export const useJobsPolling = () => {
  const dispatch = useDispatch()
  const { sessionID, polledJobsList } = useSessionStatusData()

  const pollFn = useCallback(() => {
    if (sessionID) {
      dispatch(pollCloneSessionJobsByID(sessionID))
    }
  }, [ sessionID, dispatch, pollCloneSessionJobsByID ])

  const shouldPoll = useCallback(() => {
    return polledJobsList?.length === 0 || polledJobsList?.some(
      job => [
        JobStatusEnum.SCHEDULED,
        JobStatusEnum.IN_PROGRESS,
      ].includes(job?.job?.status),
    )
  }, [ sessionID, polledJobsList ])

  usePolling({
    pollFn,
    shouldPoll,
    interval: POLL_INTERVAL,
    withEagerPolling: true,
  })
}

export default useJobsPolling
